import { Injectable } from '@kaokei/use-vue-service';
import { DaoService } from './dao.service';

import { ContestDetailInfo } from '@/types';
import EventBusItemDetail from '@/eventBus/itemDetail';

@Injectable()
export class ItemService {
  public item!: ContestDetailInfo;
  public statusTimer!: any;

  constructor(public daoService: DaoService) {}

  public getContestDetailInfo(id: number, params = {}) {
    clearInterval(this.statusTimer);
    return this.daoService
      .getContestDetailInfo(id, params)
      .then(info => {
        this.item = info;
        EventBusItemDetail.emit('item-new', info);
        // 待考试状态，定时2s自动刷新数据
        if (info.buttonId === 4) {
          this.statusTimer = setInterval(() => {
            if (info.examStartTime && info.examStartTime < Date.now()) {
              // 达到本地时间后，随机延迟0～4s执行请求
              const randomSecound = Math.floor(Math.random() * 5) * 1000;
              setTimeout(() => {
                this.getContestDetailInfo(id);
              }, randomSecound);
              clearInterval(this.statusTimer);
            }
          }, 2000);
        }
      })
      .catch(e => {
        clearInterval(this.statusTimer);
        if (e?.errCode === 10000) {
          window.location.reload();
        }
      });
  }

  public clearTimer() {
    clearInterval(this.statusTimer);
  }

  public get itemList() {
    if (this.item && this.item.contestNavigationBarRespList) {
      return this.item.contestNavigationBarRespList.filter(
        item => item.navBarName && item.navBarText
      );
    }
    return [];
  }
}
